import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../components/UserContext';
import CustomerInsights from '../../components/CustomerInsights';

const FullscreenInsights = () => {
    const navigate = useNavigate();
    const { user, restaurant } = useContext(UserContext);
    const restaurantId = restaurant?._id || user?.id;

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-4">
            <div className="max-w-7xl mx-auto">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
                        📊 Customer Insights Dashboard
                    </h1>
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg transition-all duration-200 shadow-md"
                    >
                        ← Back
                    </button>
                </div>
                <CustomerInsights restaurantId={restaurantId} />
            </div>
        </div>
    );
};

export default FullscreenInsights;